import api from '../../api'
import moment from 'moment'

import {
    CREATE_NEW_APPRAISALQUOTE,
    DELETE_APPRAISALQUOTE,
    GET_APPRAISALQUOTE,
    RESET_APPRAISALQUOTE,
    SET_APPRAISALQUOTE,
    SET_APPRAISALQUOTE_FILE_ID,
    SET_APPRAISALQUOTE_ID,
    SET_APPRAISALQUOTE_DATE_CREATED,
    SET_APPRAISALQUOTE_DATE_MODIFIED,
    SET_APPRAISALQUOTE_DIRTYNESS,
    SET_APPRAISALQUOTE_NUMBER,
    SET_APPRAISALQUOTE_PARENT_PATH,
    SET_APPRAISALQUOTE_PATH,
    UPDATE_APPRAISALQUOTE,
    SET_APPRAISALQUOTE_DESCRIPTION,
    SET_APPRAISALQUOTE_REPORTDATE,
    SET_APPRAISALQUOTE_SEND_TO_BDE,
    SET_APPRAISALQUOTE_TITLE,
    SET_APPRAISALQUOTE_VERSION,
    SET_APPRAISALQUOTE_PETITIONER,
    SET_APPRAISALQUOTE_PETITIONER_TYPE,
    SET_APPRAISALQUOTE_ENTITY,
    SET_APPRAISALQUOTE_SUPERVISOR,
    SET_APPRAISALQUOTE_APPRAISER,
    SET_APPRAISALQUOTE_COVER_PHOTO_URL,
    SET_APPRAISALQUOTE_VAT_PCT,
    SET_APPRAISALQUOTE_STATUS,
    SET_APPRAISALQUOTE_BANK_NAME,
    SET_APPRAISALQUOTE_IBAN,
    SET_APPRAISALQUOTE_COURT_ASSISTANCE_FEES,
    SET_APPRAISALQUOTE_DISCOUNT_PCT,
    SET_APPRAISALQUOTE_DISCOUNT_NOTES,
    SET_APPRAISALQUOTE_FINAL_PRICE,
    SET_APPRAISALQUOTE_REQUIREDDOC,
    SET_APPRAISALQUOTE_FULL_NUMBER,
    SET_APPRAISALQUOTE_SIGNATURE_NAME,
    SET_APPRAISALQUOTE_SIGNATURE_BASE64,
    SET_APPRAISALQUOTE_SIGNATURE_DATE,
    SET_APPRAISALQUOTE_IS_SIGNED,
    SET_APPRAISALQUOTE_SIGNATURE_UID,
    SET_APPRAISALQUOTE_SIGNATURE_EMAIL,
    SET_APPRAISALQUOTE_PURPOSE,



} from '../../constants'

const default_state = {
    date_created: null,
    date_modified: null,
    dirty: false,
    id: null,
    path: null,
    description: null,
    number: null,
    full_number: null,
    quotedate: null,
    send_to_bde: false,
    title: null,
    vat_pct: 21,
    version: null,
    petitioner: null,
    petitioner_type: {
        id: 1,
        'name_ca': 'Altres persones físiques o jurídiques',
        'name_en': 'Other natural or legal persons',
        'name_es': 'Otras personas físicas o jurídicas'
    },
    entity: null,
    supervisor: {
        complete_name: 'López-Doriga, Ferran',
        id: '-L-K_d-_ZNBuuqfNtjJy',
        name: 'Ferran',
        path: 'supervisors',
        prof_assoc_reg_number: '9830-2',
        surnames: 'López-Doriga',
        tin: '46108653R'
    },
    appraiser: null,
    cover_photo_url: null,
    status: {
        id: 1,
        level: 1,
        progress_coef: 0.166,
        name_ca: '1/6 - Falta la firma del Director Financer (CFO)',
        name_es: '1/6 - Falta la firma del Director Financiero (CFO)',
        name_en: '1/6 - Needs to be signed by CFO'
    },
    bank_name: 'CAIXABANK',
    iban: 'ES09 2100 0911 01 0200176881',
    court_assistance_fees: 200,
    discount_pct: 0,
    discount_notes: null,
    final_price: 0,
    requireddoc: null,
    signature_name: null,
    signature_base64: null,
    signature_date: null,
    signature_email: null,
    signature_uid: null,
    purpose: null,


}

const state = default_state

const actions = {

    CREATE_NEW_APPRAISALQUOTE: ({state, commit, rootState}, data) => {

        return new Promise((resolve, reject) => {
            api.create({key: data.key, path: data.path})
                .then((res) => {
                    const new_created_key = res.key
                    const default_appraisalquotedate = moment(res.date_created, 'x').format('YYYY-MM-DD')

                    commit(SET_APPRAISALQUOTE_ID, res.key)
                    commit(SET_APPRAISALQUOTE_DATE_CREATED, res.date_created)
                    commit(SET_APPRAISALQUOTE_DATE_MODIFIED, res.date_modified)
                    commit(SET_APPRAISALQUOTE_NUMBER, data.number)
                    commit(SET_APPRAISALQUOTE_PATH, res.path)
                    commit(SET_APPRAISALQUOTE_PARENT_PATH, data.parent_path)
                    commit(SET_APPRAISALQUOTE_REPORTDATE, default_appraisalquotedate)
                    commit(SET_APPRAISALQUOTE_VERSION, data.version)
                    commit(SET_APPRAISALQUOTE_FULL_NUMBER, data.full_number)
                    commit(SET_APPRAISALQUOTE_FILE_ID, data.file_id)

                    // 1514764800 = 1 gener 2018 en unix timestamp

                    const requireddocs_object = {
                        '1514764800': {
                            id: '1514764800',
                            name_ca: 'Nom, NIF i adreça del sol·licitant',
                            name_es: 'Nombre, NIF y dirección del solicitante',
                            name_en: 'Petitioner details: Name, tax identification number, ID and address'
                        },
                        '1514764801': {
                            id: '1514764801',
                            name_ca: 'Nom, NIF i adreça fiscal per a la factura',
                            name_es: 'Nombre, NIF y dirección fiscal para la factura',
                            name_en: 'Invoice details: Name, tax identification number and fiscal address'
                        },
                        '1514764802': {
                            id: '1514764802',
                            name_ca: 'Còpia completa de l\'escriptura o de la nota registral',
                            name_es: 'Copia completa de la escritura o de la nota registral',
                            name_en: 'Full copy of the property deed or registration note'
                        },
                        '1514764803': {
                            id: '1514764803',
                            name_ca: 'Còpia de rebut de l\'I.B.I. (Dades Cadastrals) (Opcional)',
                            name_es: 'Copia de recibo del I.B.I. (Datos Cadastrales) (Opcional)',
                            name_en: 'Property tax payment receipt copy (Cadastral data) (Optional)'
                        },
                        '1514764804': {
                            id: '1514764804',
                            name_ca: 'Plànol de la finca (Opcional)',
                            name_es: 'Plano de la finca (Opcional)',
                            name_en: 'Plan of the property (Optional)'
                        },
                        '1514764805': {
                            id: '1514764805',
                            name_ca: 'Còpia del contracte de lloguer i un rebut actualitzat (en el cas d\'estar llogat)',
                            name_es: 'Copia del contrato de alquiler y un recibo actualizado (en el caso de estar alquilado)',
                            name_en: 'Full copy of the rental contract and an updated receipt (in the event of being rented)'
                        },
                        '1514764806': {
                            id: '1514764806',
                            name_ca: 'Finalitat de la taxació (adquisició o venda, constituir garanties hipotecàries, expropiació,...)',
                            name_es: 'Finalidad de la tasación (adquisición o venta, constituir garantías hipotecarias, expropiación... )',
                            name_en: 'Valuation purpose (Acquisition or sale, to provide mortgage guarantees, expropiation...)'
                        },
                        '1514764807': {
                            id: '1514764807',
                            name_ca: 'Nom i telèfon de la persona de contacte per a visitar la finca',
                            name_es: 'Nombre y teléfono de la persona de contacto para visitar la finca',
                            name_en: 'Name and telephone number of the contact person in order to visit the property'
                        }
                    }

                    api.set_value({
                        value: res.key,
                        path: data.path + new_created_key + '/' + 'id',
                        save_timestamp: false
                    }).then((res) => {
                        api.set_value({
                            value: default_appraisalquotedate,
                            path: data.path + new_created_key + '/' + 'quotedate',
                            save_timestamp: false
                        }).then((res) => {
                            api.set_value({
                                value: data.file_id,
                                path: data.path + new_created_key + '/' + 'file_id',
                                save_timestamp: false
                            }).then((res) => {
                                api.set_value({
                                    value: data.number,
                                    path: data.path + new_created_key + '/' + 'number',
                                    save_timestamp: false
                                }).then((res) => {
                                    api.set_value({
                                        value: data.version,
                                        path: data.path + new_created_key + '/' + 'version',
                                        save_timestamp: false
                                    }).then((res) => {
                                        api.set_value({
                                            value: data.full_number,
                                            path: data.path + new_created_key + '/' + 'full_number',
                                            save_timestamp: false
                                        }).then((res) => {
                                            api.set_value({
                                                value: data.parent_path,
                                                path: data.path + new_created_key + '/' + 'parent_path',
                                                save_timestamp: false
                                            }).then((res) => {
                                                api.set_value({
                                                    value: requireddocs_object,
                                                    path: data.path + new_created_key + '/' + 'requireddocs',
                                                    save_timestamp: false
                                                }).then((res) => {
                                                    api.set_value({
                                                        value: default_appraisalquotedate,
                                                        path: data.path + new_created_key + '/' + 'quotedate',
                                                        save_timestamp: false
                                                    }).then((res) => {
                                                        const object = {}
                                                        object[new_created_key] = {
                                                            description: '',
                                                            id: new_created_key,
                                                            number: data.number,
                                                            version: data.version,
                                                            full_number: data.full_number
                                                        }
                                                        api.update({
                                                            object: object,
                                                            path: data.parent_path,
                                                            save_timestamp: false
                                                        }).then(res => resolve({key: new_created_key}))
                                                    })
                                                })
                                            })
                                        })
                                    })
                                })
                            })
                        })
                    })
                })

        })

    },
    DELETE_APPRAISALQUOTE: ({state, commit, rootState}, data) => {

        // console.log('DELETE_APPRAISALQUOTE path check: ' + data.path)
        // console.log('DELETE APPRAISALQUOTE parent_path check: ' + data.parent_path)

        // delete from appraisalquotes/appraisalquote_key
        api.delete({key: data.key, path: data.path})
            .then((res) => {

                const date_modified = res.date_modified

                // delete from appraisalfiles/appraisalfile_key/appraisalquotes/appraisalquote_key
                api.delete({key: data.key, path: data.parent_path})
                    .then((res) => {
                        commit(RESET_APPRAISALQUOTE)

                        api.set_value({
                            value: date_modified,
                            path: 'appraisalfiles' + '/' + data.file_id + '/' + 'date_modified',
                            save_timestamp: false
                        })
                            .then((res) => {

                            })

                    })
            })

    },
    GET_APPRAISALQUOTE: ({state, commit, rootState}, data) => {

        return new Promise((resolve, reject) => {
            return api.get({path: data.path})
                .then(res => resolve(res))
        })

    },
    SET_APPRAISALQUOTE: ({state, commit, rootState}, data) => {

        // console.log('set_appraisalquote data:')
        // console.log(data)
        return api.get({path: data.path})
            .then((res) => {
                console.log(res)
                commit(SET_APPRAISALQUOTE, res)
            })

    },
    RESET_APPRAISALQUOTE: ({state, commit, rootState}) => {
        commit(RESET_APPRAISALQUOTE)
    },
    SET_APPRAISALQUOTE_REPORTDATE: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISALQUOTE_REPORTDATE, data)
    },
    SET_APPRAISALQUOTE_DATE_CREATED: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISALQUOTE_DATE_CREATED, data)
    },
    SET_APPRAISALQUOTE_DATE_MODIFIED: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISALQUOTE_DATE_MODIFIED, data)
    },

    SET_APPRAISALQUOTE_FILE_ID: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISALQUOTE_FILE_ID, data)
    },
    SET_APPRAISALQUOTE_ID: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISALQUOTE_ID, data)
    },
    SET_APPRAISALQUOTE_NUMBER: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISALQUOTE_NUMBER, data)
    },
    SET_APPRAISALQUOTE_FULL_NUMBER: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISALQUOTE_FULL_NUMBER, data)
    },
    SET_APPRAISALQUOTE_PARENT_PATH: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISALQUOTE_PARENT_PATH, data)
    },
    SET_APPRAISALQUOTE_PATH: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISALQUOTE_PATH, data)
    },
    SET_APPRAISALQUOTE_SEND_TO_BDE: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISALQUOTE_SEND_TO_BDE, data)
    },
    SET_APPRAISALQUOTE_TITLE: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISALQUOTE_TITLE, data)
    },
    SET_APPRAISALQUOTE_VERSION: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISALQUOTE_VERSION, data)
    },
    UPDATE_APPRAISALQUOTE: ({state, commit, rootState}, data) => {
        return new Promise((resolve, reject) => {
            // console.log('UPDATE_APPRAISALQUOTE data:')
            // console.log(data)
            api.update({object: data.object, path: data.path + data.key, save_timestamp: true})
                .then((res) => {

                    const date_modified = res.date_modified
                    commit(SET_APPRAISALQUOTE_DATE_MODIFIED, res.date_modified)
                    commit(SET_APPRAISALQUOTE_DIRTYNESS, false)

                    let parent_object = {}

                    parent_object = {
                        description: data.object.description,
                        id: data.object.id,
                        date_modified: res.date_modified,
                        number: data.object.number,
                        version: data.object.version,
                        full_number: data.object.full_number,
                        send_to_bde: data.object.send_to_bde
                    }
                    api.update({object: parent_object, path: data.parent_path + data.key, save_timestamp: false})
                        .then((res) => {

                            // update file date_modified
                            api.set_value({
                                value: date_modified,
                                path: 'appraisalfiles' + '/' + data.object.file_id + '/' + 'date_modified',
                                save_timestamp: false
                            })
                                .then(res => resolve({key: res.key}))

                        })
                })

        })
    },
    SET_APPRAISALQUOTE_REALESTATE_APPRAISAL_ID: ({state, commit, rootState}, data) => {
        return new Promise((resolve, reject) => {
            api.set_value({
                value: data.value,
                path: data.path,
                save_timestamp: false
            })
                .then(() => {
                    resolve()

                })

        })
    },
    UPDATE_APPRAISALQUOTE_REALESTATE_APPRAISAL_ID: ({state, commit, rootState}, data) => {
        return new Promise((resolve, reject) => {
            api.set_value({
                value: data.appraisal_id,
                path: 'appraisalquotes' + '/' + data.appraisalquote_id + '/' + 'realestates' + '/' + data.realestate_id + '/' + 'appraisal_id',
                save_timestamp: false
            })
            api.set_value({
                value: data.appraisaldate,
                path: 'appraisalquotes' + '/' + data.appraisalquote_id + '/' + 'realestates' + '/' + data.realestate_id + '/' + 'appraisals' + '/' + data.appraisal_id + '/' + 'appraisaldate',
                save_timestamp: false
            })
            api.set_value({
                value: data.appraisal_id,
                path: 'appraisalquotes' + '/' + data.appraisalquote_id + '/' + 'realestates' + '/' + data.realestate_id + '/' + 'appraisals' + '/' + data.appraisal_id + '/' + 'id',
                save_timestamp: false
            })
                .then(() => {
                    resolve()

                })

        })
    },
    SET_APPRAISALQUOTE_DESCRIPTION: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISALQUOTE_DESCRIPTION, data)
    },
    SET_APPRAISALQUOTE_PETITIONER: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISALQUOTE_PETITIONER, data)
    },
    SET_APPRAISALQUOTE_PETITIONER_TYPE: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISALQUOTE_PETITIONER_TYPE, data)
    },
    SET_APPRAISALQUOTE_ENTITY: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISALQUOTE_ENTITY, data)
    },
    SET_APPRAISALQUOTE_SUPERVISOR: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISALQUOTE_SUPERVISOR, data)
    },
    SET_APPRAISALQUOTE_APPRAISER: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISALQUOTE_APPRAISER, data)
    },
    SET_APPRAISALQUOTE_COVER_PHOTO_URL: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISALQUOTE_COVER_PHOTO_URL, data)
    },
    SET_APPRAISALQUOTE_VAT_PCT: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISALQUOTE_VAT_PCT, data)
    },
    SET_APPRAISALQUOTE_STATUS: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISALQUOTE_STATUS, data)
    },
    SET_APPRAISALQUOTE_BANK_NAME: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISALQUOTE_BANK_NAME, data)
    },
    SET_APPRAISALQUOTE_IBAN: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISALQUOTE_IBAN, data)
    },
    SET_APPRAISALQUOTE_COURT_ASSISTANCE_FEES: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISALQUOTE_COURT_ASSISTANCE_FEES, data)
    },
    SET_APPRAISALQUOTE_DISCOUNT_PCT: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISALQUOTE_DISCOUNT_PCT, data)
    },
    SET_APPRAISALQUOTE_DISCOUNT_NOTES: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISALQUOTE_DISCOUNT_NOTES, data)
    },
    SET_APPRAISALQUOTE_FINAL_PRICE: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISALQUOTE_FINAL_PRICE, data)
    },
    SET_APPRAISALQUOTE_REQUIREDDOC: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISALQUOTE_REQUIREDDOC, data)
    },
    SET_APPRAISALQUOTE_SIGNATURE_NAME: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISALQUOTE_SIGNATURE_NAME, data)
    },
    SET_APPRAISALQUOTE_SIGNATURE_BASE64: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISALQUOTE_SIGNATURE_BASE64, data)
    },
    SET_APPRAISALQUOTE_SIGNATURE_DATE: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISALQUOTE_SIGNATURE_DATE, data)
    },
    SET_APPRAISALQUOTE_SIGNATURE_EMAIL: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISALQUOTE_SIGNATURE_EMAIL, data)
    },
    SET_APPRAISALQUOTE_SIGNATURE_UID: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISALQUOTE_SIGNATURE_UID, data)
    },
    SET_APPRAISALQUOTE_PURPOSE: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISALQUOTE_PURPOSE, data)
    },

}

const mutations = {

    [RESET_APPRAISALQUOTE] (state) {
        state.date_created = null
        state.date_modified = null
        state.dirty = false
        state.file_id = null
        state.id = null
        state.number = null
        state.full_number = null
        state.path = null
        state.parent_path = null
        state.description = null
        state.quotedate = null
        state.send_to_bde = null
        state.title = null
        state.version = null
        state.petitioner = null
        state.petitioner_type = {
            id: 1,
            'name_ca': 'Altres persones físiques o jurídiques',
            'name_en': 'Other natural or legal persons',
            'name_es': 'Otras personas físicas o jurídicas'
        }
        state.entity = null
        state.supervisor = null
        state.appraiser = null
        state.cover_photo_url = null
        state.vat_pct = 21
        state.status = {
            id: 1,
            level: 1,
            progress_coef: 0.166,
            name_ca: '1/6 - Falta la firma del Director Financer (CFO)',
            name_es: '1/6 - Falta la firma del Director Financiero (CFO)',
            name_en: '1/6 - Needs to be signed by CFO'
        }
        state.bank_name = 'CAIXABANK'
        state.iban = 'ES09 2100 0911 01 0200176881'
        state.court_assistance_fees = 200
        state.discount_pct = 0
        state.discount_notes = null
        state.final_price = 0
        state.requireddoc = null
        state.signature_name = null
        state.signature_base64 = null
        state.signature_date = null
        state.signature_email = null
        state.signature_uid = null
        state.purpose = null



    },
    [SET_APPRAISALQUOTE] (state, data) {
        state.date_created = check_undefined(data.date_created)
        state.date_modified = check_undefined(data.date_modified)
        state.dirty = false
        state.file_id = check_undefined(data.file_id)
        state.id = check_undefined(data.id)
        state.number = check_undefined(data.number)
        state.full_number = check_undefined(data.full_number)
        state.path = check_undefined(data.path)
        state.parent_path = check_undefined(data.parent_path)
        state.description = check_undefined(data.description)
        state.quotedate = check_undefined(data.quotedate)
        state.send_to_bde = check_undefined(data.send_to_bde)
        state.title = check_undefined(data.title)
        state.version = check_undefined(data.version)
        state.petitioner = check_undefined(data.petitioner)
        state.petitioner_type = check_undefined(data.petitioner_type)
        state.entity = check_undefined(data.entity)
        state.supervisor = check_undefined(data.supervisor)
        state.appraiser = check_undefined(data.appraiser)
        state.cover_photo_url = check_undefined(data.cover_photo_url)
        state.vat_pct = check_undefined(data.vat_pct)
        state.status = check_undefined(data.status)
        state.bank_name = check_undefined(data.bank_name)
        state.iban = check_undefined(data.iban)
        state.court_assistance_fees = check_undefined(data.court_assistance_fees)
        state.discount_pct = check_undefined(data.discount_pct)
        state.discount_notes = check_undefined(data.discount_notes)
        state.final_price = check_undefined(data.final_price)
        state.requireddoc = check_undefined(data.requireddoc)
        state.signature_name = check_undefined(data.signature_name)
        state.signature_base64 = check_undefined(data.signature_base64)
        state.signature_date = check_undefined(data.signature_date)
        state.signature_email = check_undefined(data.signature_email)
        state.signature_uid = check_undefined(data.signature_uid)
        state.purpose = check_undefined(data.purpose)


    },
    [SET_APPRAISALQUOTE_DATE_CREATED] (state, data) {
        state.date_created = data
        state.dirty = true
    },
    [SET_APPRAISALQUOTE_DATE_MODIFIED] (state, data) {
        state.date_modified = data
        state.dirty = true
    },
    [SET_APPRAISALQUOTE_DIRTYNESS] (state, boolean) {
        state.dirty = boolean
    },
    [SET_APPRAISALQUOTE_FILE_ID] (state, data) {
        state.file_id = data
        state.dirty = true
    },
    [SET_APPRAISALQUOTE_ID] (state, data) {
        state.id = data
        state.dirty = true
    },
    [SET_APPRAISALQUOTE_NUMBER] (state, data) {
        state.number = data
        state.dirty = true
    },
    [SET_APPRAISALQUOTE_FULL_NUMBER] (state, data) {
        state.full_number = data
        state.dirty = true
    },
    [SET_APPRAISALQUOTE_PARENT_PATH] (state, data) {
        state.parent_path = data
        state.dirty = true
    },
    [SET_APPRAISALQUOTE_PATH] (state, data) {
        state.path = data
        state.dirty = true
    },
    [SET_APPRAISALQUOTE_REPORTDATE] (state, data) {
        state.quotedate = data
        state.dirty = true
    },
    [SET_APPRAISALQUOTE_TITLE] (state, data) {
        state.title = data
        state.dirty = true
    },
    [SET_APPRAISALQUOTE_DESCRIPTION] (state, data) {
        state.description = data
        state.dirty = true
    },
    [SET_APPRAISALQUOTE_VERSION] (state, data) {
        state.version = data
        state.dirty = true
    },
    [SET_APPRAISALQUOTE_PETITIONER] (state, data) {
        state.petitioner = data
        state.dirty = true
    },
    [SET_APPRAISALQUOTE_PETITIONER_TYPE] (state, data) {
        state.petitioner_type = data
        state.dirty = true
    },
    [SET_APPRAISALQUOTE_ENTITY] (state, data) {
        state.entity = data
        state.dirty = true
    },
    [SET_APPRAISALQUOTE_SUPERVISOR] (state, data) {
        state.supervisor = data
        state.dirty = true
    },
    [SET_APPRAISALQUOTE_APPRAISER] (state, data) {
        state.appraiser = data
        state.dirty = true
    },
    [SET_APPRAISALQUOTE_COVER_PHOTO_URL] (state, data) {
        state.cover_photo_url = data
        state.dirty = true
    },
    [SET_APPRAISALQUOTE_VAT_PCT] (state, data) {
        state.vat_pct = data
        state.dirty = true
    },
    [SET_APPRAISALQUOTE_STATUS] (state, data) {
        state.status = data
        state.dirty = true
    },
    [SET_APPRAISALQUOTE_BANK_NAME] (state, data) {
        state.bank_name = data
        state.dirty = true
    },
    [SET_APPRAISALQUOTE_IBAN] (state, data) {
        state.iban = data
        state.dirty = true
    },
    [SET_APPRAISALQUOTE_COURT_ASSISTANCE_FEES] (state, data) {
        state.court_assistance_fees = data
        state.dirty = true
    },
    [SET_APPRAISALQUOTE_DISCOUNT_PCT] (state, data) {
        state.discount_pct = data
        state.dirty = true
    },
    [SET_APPRAISALQUOTE_DISCOUNT_NOTES] (state, data) {
        state.discount_notes = data
        state.dirty = true
    },
    [SET_APPRAISALQUOTE_FINAL_PRICE] (state, data) {
        state.final_price = data
        state.dirty = true
    },
    [SET_APPRAISALQUOTE_REQUIREDDOC] (state, data) {
        state.requireddoc = data
        state.dirty = true
    },
    [SET_APPRAISALQUOTE_SIGNATURE_NAME] (state, data) {
        state.signature_name = data
        state.dirty = true
    },
    [SET_APPRAISALQUOTE_SIGNATURE_BASE64] (state, data) {
        state.signature_base64 = data
        state.dirty = true
    },
    [SET_APPRAISALQUOTE_SIGNATURE_DATE] (state, data) {
        state.signature_date = data
        state.dirty = true
    },
    [SET_APPRAISALQUOTE_SIGNATURE_EMAIL] (state, data) {
        state.signature_email = data
        state.dirty = true
    },
    [SET_APPRAISALQUOTE_SIGNATURE_UID] (state, data) {
        state.signature_uid = data
        state.dirty = true
    },
    [SET_APPRAISALQUOTE_PURPOSE] (state, data) {
        state.purpose = data
        state.dirty = true
    },
}

function check_undefined (myVar) {
    if (typeof myVar !== 'undefined') {
        return myVar
    } else {
        return null
    }
}

const getters = {

    appraisalquote: state => {
        return state
    }
}

export default {
    state,
    actions,
    mutations,
    getters
}


// WEBPACK FOOTER //
// ./src/store/modules/appraisalquote/appraisalquote.js